<template>
    <div class="integralTicketBox">
        <md-tab-bar
                v-model="current"
                :items="items"
        />
        <div class="scrollBox">
            <div class="scrollContent">
                <div @click="goToIntegralTicketConvertFn(item)" class="integral integralState1" v-for="(item, index) in dataList" :key="index">
                    <div class="left">
                        <div class="number numberState1">
                            <span>{{item.subtitle}}</span>
                        </div>
                        <div class="textBox">
                            <div class="jifeng numberState1">元</div>
                            <div class="quan quanState1">
                                <span>{{item.title}}</span>
                                <span class="credits" v-if="item.ticketScore">{{item.ticketScore}}积分</span>
                            </div>
                        </div>
                    </div>
                    <div class="right">
                        <div class="text-left textState1">
                            <span v-if="current == '1'">商场券</span>
                            <span v-if="current == '2'">品牌券</span>
                            <span v-if="current == '3'">停车券</span>
                            <span v-if="current == '4'">已过期</span>
                        </div>
                        <div class="text-right textState1">
                            <span>有效期：{{item.beginDate}} ~ {{item.endDate}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "myCoupon",
        mounted() {
            if('plate' in this.$route.query){
                this.state = true //是从停车缴费跳过来
                this.current = 3 //停车券
                this.plate = JSON.parse(this.$route.query.plate)

            }
            document.title = "我的卡券"
            this.userData = JSON.parse(localStorage.getItem("userData"))
            let dt = new URLSearchParams()
            dt.append('cardNo', this.userData.cardAccount)
            this.$http.post('/sangto-wrm/vip/coupons/getCoupons', dt).then(({data})=>{

                //brandList 品牌券
                //invalidList 过期
                //marketList 市场券
                //parkList 停车券
                let {brandList, invalidList, marketList, parkList} = data.data
                brandList.forEach(item =>{
                    item.subtitle = Number(item.subtitle)
                    item.beginDate = item.beginDate.split(' ')[0]
                    item.endDate = item.endDate.split(' ')[0]
                })
                invalidList.forEach(item =>{
                    item.subtitle = Number(item.subtitle)
                    item.beginDate = item.beginDate.split(' ')[0]
                    item.endDate = item.endDate.split(' ')[0]
                })
                marketList.forEach(item =>{
                    item.subtitle = Number(item.subtitle)
                    item.beginDate = item.beginDate.split(' ')[0]
                    item.endDate = item.endDate.split(' ')[0]
                })
                parkList.forEach(item =>{
                    item.subtitle = Number(item.subtitle)
                    item.beginDate = item.beginDate.split(' ')[0]
                    item.endDate = item.endDate.split(' ')[0]
                })

                this.brandList = brandList
                this.invalidList = invalidList
                this.marketList = marketList
                this.parkList = parkList
            })
        },
        computed:{
          dataList(){
              let arr = []
              if(this.current == 1){
                  arr = this.marketList
              }else if(this.current == 2){
                  arr = this.brandList
              }else if(this.current == 3){
                  arr = this.parkList
              }else if(this.current == 4){
                  arr = this.invalidList
              }

              return arr
          }
        },
        data(){
            return{
                current: 1,
                items: [{name: 1, label: '商场券'}, {name: 2, label: '品牌券'},{name: 3, label: '停车券'},{name:4, label:'已用/过期'}],
                userData:'',
                brandList:'', //品牌
                invalidList:'', //过期
                marketList:'', //商场券
                parkList:'', //停车券
                state:false, //判断是否是从停车缴费跳转过来
                plate:'', //停车缴费信息
            }
        },
        methods: {
            goToIntegralTicketConvertFn(item) {
                if(this.state){
                    //停车跳转
                    if(this.current == 3){
                        this.UI.Dialog.confirm({
                            title: '确认',
                            content: '确认使用这张券吗 ?此操作不可逆!',
                            confirmText: '确定',
                            onConfirm: () =>{
                                this.plate.payseqno +=1
                                let q = item.subtitle //券金额
                                let carM = this.plate.paidMoney/ 100
                                let Fc = 0
                                if(q < carM){
                                    Fc = q
                                }else{
                                    Fc = carM
                                }
                                let dt = new URLSearchParams()
                                dt.append('carparkfeeno', this.plate.parkno)
                                dt.append('payseqno', this.plate.payseqno)
                                dt.append('paycodeusemode', 'CPT')
                                dt.append('paymoney', Fc)
                                dt.append('giftno', ''+item.cardNo+'') //券号
                                this.$http.post('/sangto-wrm/vip/park/payMoney', dt).then(({data})=>{

                                    let da = data.data

                                    if('code' in  da){
                                        if(da.code == 0){
                                            this.$router.push({name:'stopCarSucceed'})
                                        }else{
                                            this.$router.push({name:'stopCarError'})
                                        }
                                    }else{

                                        this.plate.paidMoney = da.owemoney*100 //核销后更新金额
                                        localStorage.setItem("plateData", JSON.stringify(this.plate))
                                        this.$router.push({path:'/carPay'}) //, query:{plate: JSON.stringify(this.plate)}
                                        // this.CarPay = da.owemoney
                                    }
                                })
                            }
                        })
                    }else if(this.current == 1 || this.current == 2){
                        this.$router.push({path:"/ticketDetails",query:{itemData:JSON.stringify(item)}})
                    }

                }else{
                    if(this.current == 1 || this.current == 2 || this.current == 3){
                        this.$router.push({path:"/ticketDetails",query:{itemData:JSON.stringify(item)}})
                    }
                }

            }
        }
    }
</script>

<style lang="scss" scoped>
    .integralTicketBox {
        width: 100%;
        height: 100%;
        .scrollBox {
            position: absolute;
            /*top: 95px;*/
            top: 50px;
            left: 0;
            right: 0;
            bottom: 0;
            overflow-x: hidden;
            overflow-y: auto;
            background-color: #fdfdfd;

            .scrollContent {
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                padding-bottom: 20px;
            }
        }

        .integral {
            position: relative;
            width: 90%;
            height: 110px;
            margin-top: 19px;
            border-radius: 5px;
            display: flex;
            align-items: center;
            flex-direction: column;
            background-color: #fff;
        }

        .integralState1 {
            box-shadow: 0px 0px 9px rgba(14, 131, 240,0.2);
        }

        .left {
            width: 92%;
            height: 69%;
            border-bottom: 1px solid #ddd;
            display: flex;
        }

        .numberState1 {
            color: rgb(14, 131, 242);
        }

        .number {
            flex: 1;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            font-size: 38px;
            font-weight: 600;
        }

        .textBox {
            flex: 3;
            display: flex;
            flex-direction: column;
        }

        .jifeng {
            font-size: 14px;
            margin-top: 24px;
            margin-left: 8px;
        }

        .numberState1 {
            color: rgb(14, 131, 242);
        }

        .quanState1 {
            color: #333;
        }

        .quan {
            font-size: 14px;
            margin-left: 8px;
            display: flex;
            justify-content: space-between;
        }

        .credits {
            padding-top: 10px;
            color: #55bab4;
            font-weight: bold;
        }

        .right {
            width: 92%;
            height: 31%;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .text-left {
            font-size: 14px;
            flex: 1;
        }

        .textState1 {
            color: #666;
        }

        .text-right {
            flex: 2;
            font-size: 12px;
            display: flex;
            justify-content: flex-end;

        }
    }
</style>
